import { useMemo } from "react";
import { useTaxonomyContext } from "../contexts/Taxonomy/TaxonomyContext";

export interface CountryMapValue {
  alpha2: string;
  id: string;
}

export interface CountryIdMapValue {
  name: string;
  alpha2: string;
}

export type CountryNameMap = Map<string, CountryMapValue>;
export type CountryIdMap = Map<string, CountryIdMapValue>;

export const useCountryNameMap = () => {
  const { countries } = useTaxonomyContext();

  const [countryNameMap, countryIdMap] = useMemo(() => {
    const nameMap: CountryNameMap = new Map();
    const idMap: CountryIdMap = new Map();
    for (const country of countries || []) {
      idMap.set(country.id, { name: country.name, alpha2: country.alpha2 });
      nameMap.set(country.name, { alpha2: country.alpha2, id: country.id });
    }
    return [nameMap, idMap];
  }, [countries]);

  return { countryNameMap, countryIdMap };
};
